export default __webpack_public_path__ + "static/media/nk-prism.c5ac69a5.jpg";